import React from 'react';
import { connect } from 'react-redux';
import Blog from './Page';
import { fetchPublicBlogPosts } from '../../modules/blog/actions';

class BlogContainer extends React.Component {
  componentWillMount() {
    this.props.fetchPublicBlogPosts();
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return <Blog {...this.props} posts={this.props.posts} loading={this.props.loading}/>;
  }
}

function mapStateToProps(state) {
  return {
    posts: state.blogPosts.publicPosts,
    loading: state.blogPosts.loading,
    language: state.preference.language,
  }
}

const mapActionsToProps = {
  fetchPublicBlogPosts,
}

export default connect(mapStateToProps, mapActionsToProps)(BlogContainer);



// WEBPACK FOOTER //
// ./src/pages/Blog/Container.js